import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  setRewardsTierError: {
    id: 'setRewardsTierError',
    defaultMessage: 'An error occurred while trying to set your rewards tier',
    description: 'Message provided when an error occurs when trying to set a rewards tier',
  },
});
